import { i18n } from '@/plugins/i18n'

export const gatewayTypes = {
    PARDAKHTYARI: 0,
    PAYMAN: 1,
    IVR: 2,
    DEDICATED: 3,
    DEPOSIT: 4,
}

export const gatewayTypeStr = {
    PARDAKHTYARI: i18n.t('gateway.gateway_types.pardakhtyari'),
    PAYMAN: i18n.t('gateway.gateway_types.payman'),
    IVR: i18n.t('gateway.gateway_types.ivr'),
    DEDICATED: i18n.t('gateway.gateway_types.dedicated'),
    DEPOSIT: i18n.t('gateway.gateway_types.deposit'),
    get(type) {
        let type_str = null;
        Object.keys(gatewayTypes).forEach(function (item) {
            if(gatewayTypes[item] === type) {
                type_str = gatewayTypeStr[item]
            }
        })

        return type_str
    }
}

export const gatewayTypeVariant = (status) => {
    if(status === gatewayTypes.PARDAKHTYARI) {
        return 'success'
    }

    if(status === gatewayTypes.PAYMAN) {
        return 'info'
    }

    if(status === gatewayTypes.IVR) {
        return 'warning'
    }

    if(status === gatewayTypes.DEDICATED) {
        return 'primary'
    }

    return 'dark'
}

export const gatewayTypeUpdateUrl = (type) => {
    if(type === gatewayTypes.PARDAKHTYARI) {
        return '/gateways/update/'
    }

    if(type === gatewayTypes.PAYMAN) {
        return '/payman/update/'
    }

    if(type === gatewayTypes.IVR) {
        return '/ivr/update/'
    }

    if(type === gatewayTypes.DEDICATED) {
        return '/dedicated/update/'
    }

    if(type === gatewayTypes.DEPOSIT) {
        return '/open-banking/deposit/update/'
    }

    return ''
}